(function($) {

	var $formInputs = $('.jq-input, .jq-textarea, .jq-select, .jq-checkbox, .jq-radio, .forms-input, .forms-textarea, .forms-prvek > select, .forms-prvek input[type="checkbox"], .forms-prvek input[type="radio"]');

	if ($formInputs.length) {

		$formInputs
			.each(setFilledState)
			.on('change', setFilledState);

	}

	function setFilledState() {
		var $input = $(this);

		var defaultValue = '';

		if ($input.prop('tagName') === 'INPUT' && $input.prop('type') === 'checkbox') {

			if ($input.is(':checked')) {
				$input.parent().addClass('is-filled');
			} else {
				$input.parent().removeClass('is-filled');
			}

		} else if ($input.prop('tagName') === 'INPUT' && $input.prop('type') === 'radio') {

			$('[name="' + $input.attr('name') + '"]').parent().removeClass('is-filled');

			if ($input.is(':checked')) {
				$input.parent().addClass('is-filled');
			}

		} else {

			if ($input.prop('tagName') === 'SELECT' && typeof $input.attr('placeholder') !== 'undefined') {
				defaultValue = $input.attr('placeholder');
			}

			if ($input.val() !== defaultValue) {
				$input.addClass('is-filled');
			} else {
				$input.removeClass('is-filled');
			}

		}
	};

})(jQuery);
